/**
 * Planity white-label.
 * https://planity.gitbook.io/white-label
 */
(function () {
  if (window.__planityBookingReady) return;
  window.__planityBookingReady = true;

  var POLYFILLS =
    'https://d2skjte8udjqxw.cloudfront.net/widget/production/2/polyfills.latest.js';
  var APP =
    'https://d2skjte8udjqxw.cloudfront.net/widget/production/2/app.latest.js';

  var scriptsLoaded = false;
  var scriptsLoading = null;
  var activeIndex = 0;

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var el = document.createElement('script');
      el.src = src;
      el.async = false;
      el.onload = resolve;
      el.onerror = reject;
      document.body.appendChild(el);
    });
  }

  function loadPlanityScripts() {
    if (scriptsLoaded) return Promise.resolve();
    if (scriptsLoading) return scriptsLoading;

    scriptsLoading = loadScript(POLYFILLS)
      .then(function () {
        return loadScript(APP);
      })
      .then(function () {
        scriptsLoaded = true;
      });

    return scriptsLoading;
  }

  function getSections() {
    return Array.prototype.slice.call(
      document.querySelectorAll('[data-planity-section]')
    );
  }

  function getWidgetEl(section) {
    return section.querySelector('.planity-booking__widget');
  }

  function buildConfig(section, container) {
    var key = section.dataset.planityApiKey;
    var color = section.dataset.planityColor || '#343434';
    var mode = section.dataset.planityMode || 'appointment';

    var config = {
      key: key,
      primaryColor: color
    };

    if (mode === 'full') {
      config.container = container;
    } else if (mode === 'account') {
      config.accountContainer = container;
    } else if (mode === 'gift') {
      config.giftVoucherContainer = container;
    } else if (mode === 'shop') {
      config.onlineShopContainer = container;
    } else {
      config.appointmentContainer = container;
    }

    return config;
  }

  function clearWidgets(sections) {
    sections.forEach(function (section) {
      var widget = getWidgetEl(section);
      if (widget) widget.innerHTML = '';
    });
  }

  function setSectionsVisibility(sections, index) {
    sections.forEach(function (section, i) {
      var widget = getWidgetEl(section);
      if (!widget) return;

      if (i === index) {
        section.classList.remove('hidden');
        widget.classList.remove('hidden');
      } else {
        section.classList.add('hidden');
        widget.classList.add('hidden');
      }
    });
  }

  function removePlanityAppScript() {
    var existing = document.querySelector('script[data-planity-app]');
    if (existing) existing.remove();
  }

  function reloadApp() {
    removePlanityAppScript();
    var appScript = document.createElement('script');
    appScript.src = APP + '?t=' + Date.now();
    appScript.dataset.planityApp = '';
    appScript.async = false;
    document.body.appendChild(appScript);
    return Promise.resolve();
  }

  function mountWidget(section) {
    var container = getWidgetEl(section);
    if (!container || !section.dataset.planityApiKey) return Promise.resolve();

    clearWidgets(getSections());
    window.planity = buildConfig(section, container);

    if (!scriptsLoaded) {
      return loadPlanityScripts();
    }

    return reloadApp();
  }

  function buildTabs(sections) {
    var first = sections[0];
    if (!first || !first.parentElement) return;

    var nav = document.createElement('nav');
    nav.className =
      'planity-booking-tabs max-w-[1600px] mx-auto px-5 md:px-10 mb-6';
    nav.setAttribute('aria-label', 'Choisir un institut');

    var list = document.createElement('div');
    list.className = 'flex flex-col sm:flex-row gap-3';

    sections.forEach(function (section, index) {
      var label =
        section.dataset.planityTitle ||
        'Institut ' + (index + 1);

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.textContent = label;
      btn.className =
        'font-lato text-sm uppercase py-4 px-6 rounded-[10px] transition-colors border border-[#343434] text-[#343434] hover:bg-[#343434] hover:text-white planity-booking-tab';
      btn.dataset.index = String(index);

      if (index === 0) {
        btn.classList.add('bg-[#343434]', 'text-white');
        btn.classList.remove('hover:bg-[#343434]', 'hover:text-white');
      }

      btn.addEventListener('click', function () {
        if (activeIndex === index) return;
        activeIndex = index;

        list.querySelectorAll('.planity-booking-tab').forEach(function (tab) {
          tab.classList.remove('bg-[#343434]', 'text-white');
          tab.classList.add(
            'border',
            'border-[#343434]',
            'text-[#343434]',
            'hover:bg-[#343434]',
            'hover:text-white'
          );
        });
        btn.classList.add('bg-[#343434]', 'text-white');
        btn.classList.remove(
          'hover:bg-[#343434]',
          'hover:text-white'
        );

        setSectionsVisibility(sections, index);
        mountWidget(sections[index]);

        sections[index].scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      list.appendChild(btn);
    });

    nav.appendChild(list);
    first.parentElement.insertBefore(nav, first);
  }

  function init() {
    var sections = getSections().filter(function (section) {
      return section.dataset.planityApiKey;
    });

    if (!sections.length) return;

    if (sections.length > 1) {
      buildTabs(sections);
      setSectionsVisibility(sections, 0);
      mountWidget(sections[0]);
    } else {
      mountWidget(sections[0]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
